import { createContext, useContext, useEffect } from 'react'

export interface WizardAction {
  label: string
  onClick: () => void
  disabled?: boolean
  loading?: boolean
}

export interface WizardFooterApi {
  setAction: (action: WizardAction | null) => void
}

export const WizardFooterContext = createContext<WizardFooterApi | null>(null)

/**
 * A step declares its primary action and the shell renders it inside the
 * persistent summary bar, so the price, the duration and the way forward are
 * always in the same place — one thumb-reach on a phone.
 */
export function useWizardAction(action: WizardAction | null, deps: unknown[]) {
  const api = useContext(WizardFooterContext)
  useEffect(() => {
    api?.setAction(action)
    return () => api?.setAction(null)
    // The action closure changes on every render; the step declares what
    // actually matters through `deps`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
